import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, EstadoCivil, SearchEstadoCivilRequest, SearchEstadoCivilResponse, SaveEstadoCivilDto } from "../model/index";
import { SharedFunctions } from '../shared.functions';

@Injectable({
  providedIn: 'root'
})
export class EstadoCivilService extends CrudService<EstadoCivil, number, SaveEstadoCivilDto, SearchEstadoCivilRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'estadoCivil', sharedFunctions);

  }

  getAll(): Observable<GenericResponse<EstadoCivil[]>> {
    return this._http.get<GenericResponse<EstadoCivil[]>>(this._serviceUrl + '', this.httpOptions);
  }

  
}